import { createContext, useContext } from 'react';
export const initialGlobalState = {
    notification: {
        message: '',
    },
    modalBasic: {
        open: false,
        title: '',
        body: null,
        buttons: [],
    },
    commercialProcessesById: null,
    commercialProcessSelected: null,
};
export const globalContext = createContext(null);
export const useGlobal = () => {
    const context = useContext(globalContext);
    if (!context) {
        throw new Error('useGlobal must be used within a GlobalProvider');
    }
    return context;
};
